module.exports = __webpack_public_path__ + "static/media/five-tokens.7240809b.svg";